import $ from "jquery";

export class VehicleDisclaimerModule {

    constructor() {
        this.$vehicleDisclaimerModal = $('.vehicle-disclaimer');
        this.$checkbox = $('#consent-vechicle-disclaimer');
        this.$consentButton = $('[data-vehicle-consent-agree]');

        this.$checkbox.on('change', (e) => {
            this.handleOnChange(e);
        });
        $('[data-vehicle-consent-agree]').on('click', (e) => {
            this.closeModal();
        });
    }

    handleOnChange(e) {
        if (this.isChecked()) {
            this.$consentButton.removeAttr('disabled');
        } else {
            this.$consentButton.attr('disabled', 'disabled');
        }
    }

    isChecked() {
        return this.$checkbox.is(':checked');
    }

    closeModal() {
        if (this.isChecked()) {
            this.$vehicleDisclaimerModal.fadeOut(1000, function(){
                $(this).remove()
            });
        }
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/App/VehicleDisclaimerModule.js